import { ContentHeader } from '@features/core/ui/layout/contentHeader.tsx';

import { Header } from '../header';

export const UserHeader = () => {
  return (
    <Header>
      <ContentHeader isUser />
    </Header>
  );
};
